function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4085 9.03064C32.4601 8.81135 31.5132 9.39518 31.2939 10.3436L28.2324 23.0652H12.9218L8.5473 5.60456C8.36503 4.80287 7.63595 4.25606 6.83426 4.25606L1.87581 4.25464C0.891846 4.25464 0.125732 5.05633 0.125732 6.00471C0.125732 6.9531 0.927425 7.75479 1.87581 7.75479H5.41154L9.786 25.2154C9.96827 26.0171 10.6973 26.5639 11.499 26.5639H29.5809C30.3826 26.5639 31.1116 26.0171 31.2939 25.2154L34.6844 11.1435C34.9393 10.2336 34.3555 9.28523 33.4085 9.03034V9.03064Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0769 31.6315C17.0769 33.363 15.6729 34.7657 13.9413 34.7657C12.2098 34.7657 10.8071 33.363 10.8071 31.6315C10.8071 29.8999 12.2098 28.4958 13.9413 28.4958C15.6729 28.4958 17.0769 29.8999 17.0769 31.6315Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3985 31.6315C29.3985 33.363 27.9944 34.7657 26.2629 34.7657C24.5313 34.7657 23.1287 33.363 23.1287 31.6315C23.1287 29.8999 24.5313 28.4958 26.2629 28.4958C27.9944 28.4958 29.3985 29.8999 29.3985 31.6315Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1544 18.179C19.4819 18.5065 19.9561 18.6887 20.3932 18.6887C20.8304 18.6887 21.3046 18.5065 21.6321 18.179L26.1162 13.6948C26.8083 13.0027 26.8083 11.8721 26.1162 11.2156C25.4242 10.5236 24.2936 10.5236 23.6371 11.2156L22.1789 12.6738L22.1804 2.72298C22.1804 1.73901 21.3787 0.9729 20.4303 0.9729C19.4463 0.9729 18.6802 1.77459 18.6802 2.72298V12.6752L17.2221 11.2171C16.53 10.525 15.3994 10.525 14.7429 11.2171C14.0509 11.9091 14.0509 13.0398 14.7429 13.6962L19.1544 18.179Z",
  fill: "black"
});

function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.14dd77ef.svg";
export { ForwardRef as ReactComponent };